import { render, staticRenderFns } from "./ImgLazy.vue?vue&type=template&id=131b6623&scoped=true&"
import script from "./ImgLazy.vue?vue&type=script&lang=js&"
export * from "./ImgLazy.vue?vue&type=script&lang=js&"
import style0 from "./ImgLazy.vue?vue&type=style&index=0&id=131b6623&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131b6623",
  null
  
)

export default component.exports